import { parseTextFullWidthToHalfWidthPositiveNumber } from "@lhd/utility";
import { ChangeEvent, useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const PositiveNumberEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  const [value, setValue] = useState(String(defaultValue ?? ""));

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value.replace(/[^0-9０-９]/g, "");

    setValue(nextValue);
    onChange?.(nextValue);
  };

  const handleBlur = () => {
    const formattedValue = parseTextFullWidthToHalfWidthPositiveNumber(value);

    setValue(formattedValue);
    onChange?.(formattedValue);
  };

  return (
    <input
      className="input-field"
      type="text"
      inputMode="numeric"
      value={value}
      pattern="[0-9]*"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default PositiveNumberEditCell;
